<template>
  <div>
    <!-- 具体商品售后 -->
    <el-dialog :title="$t('message.afterSaleOfSpecificGoods')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1800px" center>
      <div class="head" v-if="detail.user">
        <!-- 配送单号： -->
        <div class="item">
          {{ $t("message.porderNumber") }}:{{ detail.porder_sn }}
          {{ detail.user.realname }}
        </div>
        <!-- 业务 -->
        <div class="item">
          {{ $t("message.business") }}: {{ detail.y_admin != null ? detail.y_admin.realname : '' }}
        </div>
        <!-- 采购 -->
        <div class="item">
          {{ $t("message.purchase") }} {{ detail.g_admin != null ? detail.g_admin.realname : '' }}
        </div>
        <!-- 配货 -->
        <div class="item">
          {{ $t("message.distribution") }}: {{ detail.p_admin != null ? detail.p_admin.realname : '' }}
        </div>
        <!-- 贴标 -->
        <div class="item" v-if="detail.fba_admin">
          {{ $t("message.labeling") }}: {{ detail.fba_admin != null ? detail.fba_admin.realname : '' }}
        </div>
        <!--联系客户  -->
        <el-button type="danger">{{ $t("message.contactCustomer") }}</el-button>
      </div>
      <div class="content">
        <div class="table">
          <ol>
            <!--  番号-->
            <li class="flex05">{{ $t("message.mash") }}</li>
            <!--  图片-->
            <li>{{ $t("message.picture") }}</li>
            <!--  商品属性-->
            <li>{{ $t("message.commodityAttribute") }}</li>
            <!--  附加服务-->
            <li>{{ $t("message.additionalServices") }}</li>
            <!--  商品数-->
            <li>{{ $t("message.numberOfGoods") }}</li>
            <!--  单价（元）-->
            <li class="flex05">{{ $t("message.priceYuan") }}</li>
            <!-- 问题图片-->
            <li>{{ $t("message.problemPic") }}</li>
            <!-- 客户反馈问题诉求（日语）-->
            <li class="flex15">
              {{ $t("message.customerFeedbackProblemRequestJP") }}
            </li>
            <!--业务售后处理意见（日语）-->
            <li class="flex15">
              {{ $t("message.adviceOnAfterSaleHandlingOfBusinessJP") }}
            </li>
            <!--  产生问题原因(内部)）-->
            <li class="flex15">
              {{ $t("message.causeOfTheProblem") }}
            </li>

            <!--赔款数量）-->
            <li>{{ $t("message.amountOfIndemnity") }}</li>
            <!--商品代赔款-->
            <li>{{ $t("message.indemnitiesForGoods") }}（円）</li>
            <!--国内运费返还-->
            <li>{{ $t("message.returnOfDomesticFreight") }}（円）</li>
            <!--手续费赔款-->
            <li>{{ $t("message.commissionIndemnity") }}（円）</li>
            <!--option赔款-->
            <li>{{ $t("message.optionForCompensation") }}（円）</li>
            <!--合计-->
            <li class="flex05">{{ $t("message.total") }}(円)</li>
          </ol>
          <!-- 列表详情 -->
          <div class="table_detail" v-for="(item, index) in detail.porder_detail" :key="index">
            <!-- 订单号分单-->
            <div class="detail_head">
              <!-- 订单 -->
              <div class="order">
                <div>
                  <p>{{ item.order_sn }}</p>
                  <p>{{ item.user.realname }}</p>
                </div>
              </div>
              <!-- 订单汇率 -->
              <div class="item">
                {{ $t("message.orderRate") }}:{{ item.exchange_rate }}円/元
              </div>
              <div class="item">
                {{ $t("message.business") }}:{{ item.y_admin != null ? item.y_admin.realname : '' }}
              </div>
              <!-- 采购 -->
              <div class="item">
                {{ $t("message.purchase") }}: {{ item.g_admin != null ? item.g_admin.realname : '' }}
              </div>
              <!-- 配货 -->
              <div class="item">
                {{ $t("message.distribution") }}:{{ item.p_admin != null ? item.p_admin.realname : '' }}
              </div>
            </div>
            <!-- 列表 -->
            <ul v-for="(items, indexs) in item.list" :key="indexs">
              <!--  番号-->
              <li class="flex05">{{ items.sorting }}</li>
              <!--  图片-->
              <li>
                <el-popover placement="right" width="300" trigger="hover">
                  <img :src="items.pic" alt="" style="width: 300px; height: 300px" />
                  <a :href="`https://detail.1688.com/offer/${items.goods_id}.html`" target="_blank" slot="reference">
                    <img :src="items.pic" alt="" style="width: 60px; height: 60px" />
                  </a>
                </el-popover>
              </li>
              <!--  商品属性-->
              <li>
                <div class="attribute">
                  <el-tooltip placement="bottom">
                    <div slot="content">
                      <div class="row" v-for="(itemDetail, itemIndex) in items.detail_y" :key="itemIndex"
                        style="margin-bottom: 5px">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                    <div>
                      <div class="row" v-for="(itemDetail, itemIndex) in items.detail_y" :key="itemIndex">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </li>
              <!--  附加服务-->
              <li>
                <div class="attribute">
                  <el-tooltip placement="bottom">
                    <div slot="content">
                      <div class="row" v-for="(opti, optiIndex) in items.option" :key="optiIndex"
                        style="margin-bottom: 3px">
                        <p v-if="opti.num > 0">
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.num }} * {{ opti.price
                          }}元</span>
                          <span v-else> {{ opti.price }}% </span>
                        </p>
                      </div>
                    </div>
                    <div style="height: 80px">
                      <div class="row" v-for="(opti, optiIndex) in items.option" :key="optiIndex">
                        <p v-if="opti.num > 0">
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.num }}*{{ opti.price
                          }}元</span>
                          <span v-else> {{ opti.price }}% </span>
                        </p>
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </li>
              <!--  商品数-->
              <li>
                <div class="attribute">
                  <!-- 购买数 -->
                  <p>
                    {{ $t("message.purchaseNumber") }}:{{ items.confirm_num }}
                  </p>
                  <!-- 发送数 -->
                  <p>
                    {{ $t("message.numberOfTransmissions") }}:{{
                      items.fasong_num
                    }}
                  </p>
                </div>
              </li>
              <!--  单价（元）-->
              <li class="flex05">{{ items.confirm_price }}</li>
              <!-- 问题图片-->
              <li>
                <div class="imgList">
                  <div class="imgs" v-for="(imgs, imgIndex) in items.client_images" :key="imgIndex"
                    @click="getIndex(index, indexs, imgIndex)">
                    <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'"
                      :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                      <el-image :src="imgs">
                        <div slot="error" class="image-slot">
                          <i class="el-icon-plus"></i>
                        </div>
                      </el-image>
                    </el-upload>
                  </div>
                </div>
              </li>
              <!-- 客户反馈问题诉求（日语）-->
              <li class="flex15">
                <el-input type="textarea" v-model="items.client_desc"></el-input>
              </li>
              <!--业务售后处理意见（日语）-->
              <li class="flex15">
                <el-input type="textarea" v-model="items.admin_desc"></el-input>
              </li>
              <!--  产生问题原因(内部)）-->
              <li class="flex15">
                <el-input type="textarea" v-model="items.internal_reason"></el-input>

              </li>
              <!--赔款数量）-->
              <li>
                <el-input type="number" v-model="items.num" onfocus="this.select()" @input="calculationTotal"></el-input>
              </li>

              <!--商品代赔款-->
              <li>
                <div class="attribute">
                  <!-- 编辑 -->
                  <el-button type="text" size="small" @click="redact(index, indexs, 'amountGoods', item)">{{
                    $t("message.redact")
                  }}</el-button>
                  <p>{{ items.amountGoods.name }}</p>
                  <p>赔付：{{ items.amountGoods.amount }}</p>
                </div>
              </li>
              <!--国内运费返还-->
              <li>
                <div class="attribute">
                  <!-- 编辑 -->
                  <el-button type="text" size="small" @click="redact(index, indexs, 'amountFreight', item)">{{
                    $t("message.redact")
                  }}</el-button>
                  <p>{{ items.amountFreight.name }}</p>
                  <p>赔付：{{ items.amountFreight.amount }}</p>
                </div>
              </li>
              <!--手续费赔款-->
              <li>
                <div class="attribute">
                  <!-- 编辑 -->
                  <el-button type="text" size="small" @click="redact(index, indexs, 'amountService', item)">{{
                    $t("message.redact")
                  }}</el-button>
                  <p>{{ items.amountService.name }}</p>
                  <p>赔付：{{ items.amountService.amount }}</p>
                </div>
              </li>
              <!--option赔款-->
              <li>
                <div class="attribute">
                  <!-- 编辑 -->
                  <el-button type="text" size="small" @click="redactOption(index, indexs, items)">{{
                    $t("message.redact")
                  }}</el-button>
                  <p v-for="(opti, optiIndex) in items.amount_option_detail" :key="optiIndex"></p>
                  <el-tooltip placement="bottom">
                    <div slot="content">
                      <div class="row" v-for="(opti, optiIndex) in items.amountOption
                        .amount_option_detail" :key="optiIndex" style="margin-bottom: 3px">
                        <p v-if="opti.refund_num > 0">
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.refund_num }} * {{ opti.price
                          }}元</span>
                          <span v-else> {{ opti.price }}% </span>
                        </p>
                      </div>
                    </div>
                    <div style="height: 80px">
                      <div class="row" v-for="(opti, optiIndex) in items.amountOption
                        .amount_option_detail" :key="optiIndex">
                        <p v-if="opti.refund_num > 0">
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.refund_num }}*{{ opti.price
                          }}元</span>
                          <span v-else> {{ opti.price }}% </span>
                        </p>
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </li>
              <!--合计-->
              <li class="flex05">{{ items.total }}</li>
            </ul>
          </div>
          <!-- 统计 -->
          <ol>
            <!--  客户界面是否显示-->
            <li class="radio">
              <span>
                {{ $t("message.whetherTheCustomerInterfaceDisplays") }}</span>
              <el-radio v-model="radio" :label="1">显示</el-radio>
              <el-radio v-model="radio" :label="0">不显示</el-radio>
            </li>

            <!--合计-->
            <li>{{ $t("message.total") }}</li>
            <!--商品代赔款-->
            <li>{{ total.num }}</li>
            <!--商品代赔款-->
            <li>{{ total.amountGoods }}</li>
            <!--国内运费返还-->
            <li>{{ total.amountFreight }}</li>
            <!--手续费赔款-->
            <li>{{ total.amountService }}</li>
            <!--option赔款-->
            <li>{{ total.amountOption }}</li>
            <!--合计-->
            <li class="flex05">{{ total.allTotal }}</li>
          </ol>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <!-- <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button> -->
        <!-- 商品售后提出 -->
        <el-button type="primary" @click="checkRepeatAfterSale">{{
          $t("message.goodsAfterSale")
        }}</el-button>
      </span>
    </el-dialog>
    <!--  退款模式编辑 -->
    <refundModeEditing ref="refundModeEditing" :amountRefundType="amountRefundType" :itemData="itemData"
      :redactIndex="redactIndex" />
    <!--  附加服务赔款 -->
    <indemnityOption ref="indemnityOption" :itemData="itemData" />
    <!-- 111 -->
  </div>
</template>
<script>

import { mapState } from "vuex";
import refundModeEditing from "./refundModeEditing";
import indemnityOption from "./indemnityOption";
export default {
  components: { refundModeEditing, indemnityOption },
  data() {
    return {
      dialogVisible: false,
      detail: {}, //详情
      index: {}, //图片索引
      redactIndex: {}, // 编辑索引
      itemData: {}, //计算赔款用
      amountRefundType: [],
      radio: 1, //客户界面是否显示
      total: {
        amountGoods: 0,
        amountFreight: 0,
        amountService: 0,
        amountOption: 0,
        allTotal: 0,
      },
      option: [],
    };
  },
  computed: {
    ...mapState({
      list: (state) => state.porderDetail.list,
    }),
  },
  methods: {
    // 售后- 提出校验是否有重复金额的记录
    checkRepeatAfterSale() {
      let datas = {
        porder_sn: this.detail.porder_sn,
        amount: this.total.allTotal
      }
      this.$api.capitalApi.checkRepeatAfterSale(datas).then((res) => {
        if (res.data.is_repeat) {
          this.$alert(`${res.data.desc}`, '提示', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            center: true,
            callback: action => {
              if (action == 'confirm') {
                this.porderGoodsStore()
              }
            }
          });
        } else {
          this.porderGoodsStore()
        }

      })
    },
    // 售后-商品-提出
    porderGoodsStore() {
      let datas = {
        after_sale_sn: this.detail.after_sale_sn,
        porder_sn: this.detail.porder_sn,
        is_client_show: this.radio,
        list: [],
      };
      // this.detail.porder_detail.forEach((item) => {
      //   item.list.forEach((items) => {
      //     datas.list.push(items);
      //   });
      // });
      for (let i = 0; i < this.detail.porder_detail.length; i++) {
        for (let j = 0; j < this.detail.porder_detail[i].list.length; j++) {
          if (this.detail.porder_detail[i].list[j].internal_reason == '') {
            return this.$message.error('产生问题原因（内部）未必填项')
          }
          datas.list.push(this.detail.porder_detail[i].list[j]);
        }
      }
      console.log(datas);
      this.$api.capitalApi.porderGoodsStore(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$router.push('/afterSale')
      });
    },
    handleAvatarSuccess(res) {
      this.detail.porder_detail[this.index.i].list[this.index.is].client_images[
        this.index.iss
      ] = res.data;
      this.$forceUpdate();
    },
    // 获取图片索引
    getIndex(i, is, iss) {
      this.index = {
        i,
        is,
        iss,
      };
    },
    //编辑
    redact(index, indexs, type, item) {
      this.redactIndex = {
        index,
        indexs,
        type,
      };
      this.itemData = JSON.parse(JSON.stringify(item));
      this.$refs.refundModeEditing.dialogVisible = true;
    },
    // 编辑成功
    editSuccessfully(data) {
      this.detail.porder_detail[this.redactIndex.index].list[
        this.redactIndex.indexs
      ][this.redactIndex.type] = data;
      this.calculationTotal();
      this.$forceUpdate();
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
      }
      return isJPG || isPNG || isSVG;
    },
    //附加服务赔款 编辑
    redactOption(index, indexs, item) {
      this.redactIndex = {
        index,
        indexs,
      };
      this.itemData = JSON.parse(JSON.stringify(item));

      this.$refs.indemnityOption.dialogVisible = true;
    },
    // 附加服务赔款 编辑 成功
    redactOptionSuccess(data) {
      this.detail.porder_detail[this.redactIndex.index].list[
        this.redactIndex.indexs
      ].amountOption.amount_option_detail = data;
      this.$forceUpdate();
      this.calculationTotal();
    },
    // 计算统计
    calculationTotal() {
      this.total = {
        amountGoods: 0,
        amountFreight: 0,
        amountService: 0,
        amountOption: 0,
        allTotal: 0,
        num: 0
      };
      this.detail.porder_detail.forEach((item) => {
        item.list.forEach((items) => {
          this.total.amountGoods += items.amountGoods.amount - 0;
          this.total.amountFreight += items.amountFreight.amount - 0;
          this.total.amountService += items.amountService.amount - 0;
          items.amountOption.amount = 0;
          items.amountOption.amount_option_detail.forEach((opti) => {
            let num = 0

            if (opti.price_type == 1) {
              if (opti.refund_num) {
                num = (
                  opti.refund_num *
                  items.confirm_price * (opti.price / 100) *
                  item.exchange_rate
                ).toFixed(0);
              }

            } else {
              if (opti.refund_num) {
                num = (
                  opti.refund_num *
                  opti.price *
                  item.exchange_rate
                ).toFixed(0);
              }

            }

            items.amountOption.amount += num - 0;
          });
          this.total.amountOption += items.amountOption.amount - 0;
          this.total.num += items.num - 0;
          // 单条统计
          items.total =
            items.amountOption.amount -
            0 +
            (items.amountGoods.amount - 0) +
            (items.amountFreight.amount - 0) +
            (items.amountService.amount - 0);
          //   合计统计
          this.total.allTotal += items.total;
        });
      });
    },
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        let datas = {
          order_detail_id_set: [],
        };
        this.list.forEach((item) => {
          if (item.checked) {
            datas.order_detail_id_set.push(item.id);
          }
        });
        // 预览数据
        this.$api.capitalApi.porderGoodsPreview(datas).then((res) => {
          // 添加提交参数
          res.data.porder_detail.forEach((item) => {
            item.list.forEach((items) => {
              items.total = 0;
              items.client_desc = "";
              items.client_images = ["", "", "", ""];
              items.admin_desc = "";
              items.admin_images = ["", "", "", ""];
              items.internal_reason = "";
              items.num = 0;
              items.amountGoods = { type: "2", amount: 0, name: "不退" };
              items.amountFreight = { type: "2", amount: 0, name: "不退" };
              items.amountService = { type: "2", amount: 0, name: "不退" };
              items.amountOption = {
                type: 2,
                amount: 0,
                amount_option_detail: [],
              };
            });
          });
          this.detail = res.data;
          this.calculationTotal()
        });
        this.$api.capitalApi.amountRefundType().then((res) => {
          this.amountRefundType = res.data;
        });
      }
    },
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-radio__inner {
  transform: scale(1.5) !important;
}

/deep/.el-textarea__inner {
  height: 100px;
}

.head {
  padding: 0 24px;
  height: 56px;
  line-height: 56px;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  margin-bottom: 16px;
  display: flex;
  position: relative;
  font-size: 14px;

  .item {
    margin-right: 60px;
  }

  .el-button {
    position: absolute;
    top: 8px;
    right: 24px;
  }
}

.content {
  padding: 16px 24px;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;

  .table_detail {
    .detail_head {
      display: flex;
      font-size: 14px;
      height: 60px;
      background: #545467;
      border-radius: 4px;
      color: #fff;
      margin-top: 20px;

      .order {
        display: flex;
        align-items: center;
        padding-left: 16px;
      }

      .item {
        margin-left: 60px;
        line-height: 60px;
      }
    }
  }

  .table {
    font-size: 12px;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;
      border: 0;

      li {
        padding: 24px 0;
        position: relative;
      }
    }

    .flex15 {
      flex: 1.5;
    }

    .flex05 {
      flex: 0.5;
    }

    .attribute {
      width: 100%;
      text-align: center;
      max-height: 100px;
      overflow: hidden;

      .el-button {
        position: absolute;
        top: 5px;
        right: 20px;
      }
    }

    .imgList {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .imgs {
        width: 40px;
        height: 40px;
        margin: 0px 0px 10px 10px;

        .el-image {
          width: 40px;
          height: 40px;
          border: 1px dashed #ccc;
          text-align: center;
          line-height: 40px;
          font-size: 20px;
          border-radius: 3px;
          cursor: pointer;
        }
      }
    }

    .radio {
      flex: 9;
      width: 100%;
      justify-content: flex-start;

      span {
        margin: 0 40px 0 13px;
      }
    }
  }

  /deep/.el-input {
    width: 80%;
  }

  /deep/.el-textarea__inner {
    width: 90%;
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}
</style>